import { SERVICE_TYPE_ERROR_MESSAGES } from '../errors';

export const validateServiceName = (value: string): string => {
  if (!value.trim()) {
    return SERVICE_TYPE_ERROR_MESSAGES.REQUIRED;
  }
  if (value.trim().length > 50) {
    return SERVICE_TYPE_ERROR_MESSAGES.NAME_TOO_LONG;
  }
  return '';
};

export const validateDescription = (value: string): string => {
  if (!value.trim()) {
    return SERVICE_TYPE_ERROR_MESSAGES.REQUIRED;
  }
  if (value.trim().length > 500) {
    return SERVICE_TYPE_ERROR_MESSAGES.DESCRIPTION_TOO_LONG;
  }
  return '';
};
